var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/prefer-default-export */
import { useTranslation } from 'react-i18next';
import ErrorPage from '../../ErrorPage';
import { useAlerts } from '../../../ui/customHooks';
import ErrorInfoWrapper from '../../../ui/atoms/ErrorInfoWrapper';
import { AccountsDataNotAvailableInfo } from '../subcomponents';
var PageToRender = function (_a) {
    var accountDropdown = _a.accountDropdown, alertsPage = _a.alertsPage, analyticsAccountInfoMessage = _a.analyticsAccountInfoMessage, clientId = _a.clientId, isPageLoaded = _a.isPageLoaded;
    var _b = useAlerts(), errorCode = _b.errorCode, hasAccountsData = _b.hasAccountsData;
    var t = useTranslation().t;
    var errorBody = t('errorPage.accountsDataNotAvailable');
    var errorTitle = t('errorPage.title');
    if (!hasAccountsData) {
        return (_jsx(AccountsDataNotAvailableInfo, __assign({ "data-test": "AccountsDataNotAvailableInfo" }, { children: _jsx(ErrorInfoWrapper, { errorBody: errorBody, errorTitle: errorTitle }) })));
    }
    if (errorCode) {
        return (_jsxs(_Fragment, { children: [accountDropdown, _jsx(ErrorPage, { isPageLoaded: isPageLoaded, analyticsAccountInfoMessage: analyticsAccountInfoMessage, clientId: clientId })] }));
    }
    return (_jsxs(_Fragment, { children: [accountDropdown, alertsPage] }));
};
export default PageToRender;
